import ScheludeMovil from "./ScheludeMovil";
import './style.css'


export default function GrillaMovil({datosProgramas, categorie, currentData}){
    return (
        <ScheludeMovil datosProgramas={datosProgramas} categorie={categorie} currentData={currentData}  />
    )
}